import { JsonEditorSchema } from "@/shared/JsonEditorSchema/models/JsonEditorSchema";
import { JsonEditorType } from "@/shared/JsonEditorSchema/models/JsonEditorType";
import { IQueueExecutionCustomReportsProp } from "@/shared/Executions/models/IQueueExecutionRequest";
import SchemaGenerator from "./SchemaGenerator";
import { CustomReportFieldType } from "@/components/CustomReports/models/CustomReportFieldType";
import { JsonEditorSchemaType } from "../models/JsonEditorCdnSchemaType";


export class CustomReportsSchemaGenerator extends SchemaGenerator<IQueueExecutionCustomReportsProp> {

    public createRootSchema(): JsonEditorSchema<IQueueExecutionCustomReportsProp> {

        const rootSchema: JsonEditorSchema<IQueueExecutionCustomReportsProp> = {
            type: 'object',
            additionalProperties: false,
            properties: {
                reports: {
                    type: 'array',
                    items: {
                        type: 'object',
                        additionalProperties: true,
                        properties: {
                            type: { type: 'string' }
                        },
                        required: ["type"]
                    }
                }
            },
            required: ['reports'],
        };

        return rootSchema;
    }

    public mapType(fieldType: any): JsonEditorType | null {
        switch (fieldType) {
            case CustomReportFieldType.Text:
            case CustomReportFieldType.Select:
            case CustomReportFieldType.SelectOrCreate:
            case CustomReportFieldType.SelectJson:
            case CustomReportFieldType.ColorPicker:
            case CustomReportFieldType.RegularExpression:
                return 'string';
            case CustomReportFieldType.Number:
                return 'number';
            case CustomReportFieldType.Boolean:
                return 'boolean';
            case CustomReportFieldType.Array:
            case CustomReportFieldType.ArrayValues:
            case CustomReportFieldType.MultiSelect:
                return 'array';
            case CustomReportFieldType.Object:
            case CustomReportFieldType.Json:
            case JsonEditorSchemaType.RuleSchema:
            case JsonEditorSchemaType.AnalysisConfigSchema:
            case JsonEditorSchemaType.CalculationSchema:
            case JsonEditorSchemaType.PlotSchema:
            case JsonEditorSchemaType.TableSchema:
            case JsonEditorSchemaType.CustomReportSchema:
                return 'object';
            default:
                return null;
        }
    }

    public populateVariants(schema: JsonEditorSchema<IQueueExecutionCustomReportsProp>, variants: Array<any>, options: any): void {

        schema.properties.reports!.items = {
            type: 'object',
            additionalProperties: options.additionalProperties,
            required: ['type'],
            allOf: variants.map((variant: any) => {
                const { type: _t, ...otherProps } = variant.properties;
                const typeValue = variant.properties.type?.enum?.[0];
                return {
                    if: {
                        properties: { type: { const: typeValue } },
                        required: ['type']
                    },
                    then: {
                        properties: otherProps,
                        ...(variant.required?.length > 1
                            ? { required: variant.required }
                            : {})
                    }
                };
            })
        };

    }
}

export default CustomReportsSchemaGenerator;
